import { ListProps } from 'react-admin';
import { BoxProps } from 'shared/mui/Box';
import { PageHeader, PageHeaderTitleProps } from 'shared/mui/PageHeader';
import { StyledListBox, StyledList } from 'shared/react-admin/Pages/ListPage/ListPage.styled';
import { Pagination } from 'shared/react-admin/Pagination/Pagination';

export type ListPageProps = {
  headerTitle?: PageHeaderTitleProps;
  actions?: (React.ReactElement | false)[] | false;
  listBoxProps?: BoxProps;
} & Omit<ListProps, 'actions'>;

export function ListPage({
  children,
  actions = false,
  headerTitle,
  listBoxProps,
  pagination = <Pagination />,
  ...restProps
}: ListPageProps): JSX.Element {
  return (
    <StyledList actions={false} pagination={pagination} {...restProps}>
      <PageHeader actions={actions} headerTitle={headerTitle} />
      <StyledListBox {...listBoxProps}>{children}</StyledListBox>
    </StyledList>
  );
}
